var App = App || {};

App.ComponentTimeline = (function ($) {
    'use strict';

    function Init() {

        $(".component-timeline").each(function () {
            Carousel($(this));
        });
    }

    function Carousel(widget) {

        const carousel = widget.find(".splide");
        const controls = widget.find(".component-timeline-controls");
        const buttons = controls.find("button");

        var splide = new Splide(carousel[0], {
            type: "loop",
            gap: "3rem",
            speed: 500
        });

        splide.on("mounted", function () {
            buttons.on("click", function () {
                const splideIndex = $(this).data("splide");
                buttons.toArray().forEach(b => {
                    b.setAttribute("aria-selected", b.getAttribute("data-splide") == splideIndex);
                });
                splide.go(splideIndex);
            });
        })

        splide.on("move", function (nextIndex, prevIndex) {
            buttons.toArray().forEach(b => {
                b.setAttribute("aria-selected", b.getAttribute("data-splide") == nextIndex);
            });
        })

        splide.mount({});
    }

    return {
        Init: Init
    };

})(jQuery);

$(function () {
    App.ComponentTimeline.Init();
});